import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { Reveal } from "../landing/Reveal";

const FLOW_A = [
  { emoji: "🎓", label: "Students", to: "CRM" },
  { emoji: "💼", label: "Recruiters", to: "Recruit" },
  { emoji: "🛒", label: "Orders", to: "Books" },
  { emoji: "📦", label: "Inventory", to: "Inventory Cloud" },
  { emoji: "📚", label: "Learning", to: "Learning Suite" },
];

const FLOW_B = ["FUNZ", "SAP BTP", "S/4HANA", "SuccessFactors", "Ariba", "Concur"];

export const Partners = () => (
  <section id="partners" data-testid="partners-section" className="relative overflow-hidden py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#06B6D4]">Partners</p>
        <h2 className="mx-auto mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Playful outside. Enterprise underneath.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-2">
        <Reveal>
          <div className="rounded-[2rem] border border-white/10 bg-white/[0.04] p-7 backdrop-blur-xl sm:p-8" data-testid="integration-flow-a">
            <p className="font-jbmono text-[10px] uppercase tracking-[0.25em] text-slate-400">
              Every action, accounted for
            </p>
            <div className="mt-6 space-y-4">
              {FLOW_A.map((f, i) => (
                <div key={f.label} className="flex items-center gap-4">
                  <span className="flex w-36 items-center gap-2.5 rounded-xl border border-white/10 bg-[#09090B]/80 px-4 py-3">
                    <span className="text-lg">{f.emoji}</span>
                    <span className="text-sm font-semibold text-slate-200">{f.label}</span>
                  </span>
                  <motion.span
                    aria-hidden="true"
                    animate={{ x: [0, 6, 0], opacity: [0.4, 1, 0.4] }}
                    transition={{ duration: 1.6, repeat: Infinity, delay: i * 0.2 }}
                    className="text-[#06B6D4]"
                  >
                    →
                  </motion.span>
                  <span className="flex-1 rounded-xl border border-[#7C3AED]/25 bg-[#7C3AED]/10 px-4 py-3 text-sm font-bold text-white">
                    {f.to}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="rounded-[2rem] border border-white/10 bg-white/[0.04] p-7 backdrop-blur-xl sm:p-8" data-testid="integration-flow-b">
            <p className="font-jbmono text-[10px] uppercase tracking-[0.25em] text-slate-400">
              SAP enterprise spine
            </p>
            <div className="mx-auto mt-6 flex max-w-[240px] flex-col items-center">
              {FLOW_B.map((s, i) => (
                <div key={s} className="flex w-full flex-col items-center">
                  <div
                    className={`w-full rounded-xl border px-4 py-3 text-center font-display text-sm font-bold ${
                      i === 0
                        ? "border-[#06B6D4]/40 bg-gradient-to-r from-[#7C3AED]/20 to-[#06B6D4]/15 text-white"
                        : "border-white/10 bg-[#09090B]/80 text-slate-200"
                    }`}
                  >
                    {s}
                  </div>
                  {i < FLOW_B.length - 1 && (
                    <motion.span
                      aria-hidden="true"
                      animate={{ y: [0, 4, 0], opacity: [0.4, 1, 0.4] }}
                      transition={{ duration: 1.5, repeat: Infinity, delay: i * 0.2 }}
                      className="py-1"
                    >
                      <ArrowDown className="h-4 w-4 text-[#06B6D4]" />
                    </motion.span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
